<div class="row row1">
  <div class="col-sm-6">
    <h2 class="overview-header">My Water</h2>
  </div>
  <div *ngIf="customerInfo && customerInfo.OrgUnitId && customerInfo.OrgUnitId == 1834" class="col-sm-6">
    <a href="https://www.paymentus.com/" target="_blank" class="btn btn-primary pay-btn">Pay My Bill</a>
  </div>
</div>

<div class="row row2">
  <div class="col-md-4">
    <div class="panel panel-card usage-top-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <app-account-details></app-account-details>
          <div class="account-container">
            <div class="row">
              <div class="col-6"><label>My MeterID: <span class="bp-text">{{meterID}}</span></label></div>
              <div class="col-6"><label>Computed Reading: <span class="bp-text">{{computedValue}} {{consumptionTypeDisplay}}</span></label></div>
              <div class="col-6"><label>Billing Period: <span class="bp-text">{{billingRange}}</span></label></div>
              <div class="col-6"><label>Consumption This Bill Period: <span class="bp-text">{{mainUsageTotal | number}} {{consumptionTypeDisplay}}</span></label></div>
              <div *ngIf="customerInfo && customerInfo.HasWaterUsageRateTableSettings" class="col-6"><label>Current Cost: <span class="bp-text">{{currentBill === 0 || currentBill === undefined ? 'N/A' : currentBill | currency}}</span></label></div>
              <div *ngIf="customerInfo && customerInfo.HasWaterUsageRateTableSettings" class="col-6"><label>Estimated Next Bill: <span class="bp-text">{{nextBill === 0 || nextBill === undefined ? 'N/A' : nextBill | currency}}</span></label></div>
              <div *ngIf="customerInfo && customerInfo.HasWaterUsageRateTableSettings" class="col-6"><label>Budget: <span class="bp-text">{{budget === 0 || budget === undefined || budget === null ? 'N/A' : budget | currency}}</span></label></div>
            </div>

            <div *ngIf="customerInfo && customerInfo.HasWaterUsageRateTableSettings" class="row margin-top-bottom-10">
              <div class="col-sm-12" style="margin-left: -15px;">
                <div type="button" (click)="configureBudget()" class="btn btn-primary">Set Budget</div>
              </div>
            </div>


            <div class="row margin-top-bottom-10" *ngIf="scheduled">
              <ul class="col-12" *ngFor="let c of pendingCommands" id="pendingCommandsUL">
                <li for="cancel"><span>{{c.commandPosition === 1 ? 'Diconnect' : 'Connect'}}</span><span> scheduled for: {{c.schedule}}</span> <input type="button" class="margin-left-10 btn-danger btn-sm" id="cancel" (click)="cancelSchedule(c.commandId)" value="Cancel" /></li>
              </ul>
            </div>

            <div class="margin-top-bottom-10" *ngIf="showDiscoSelect">
              <label class="bp-text float-left"><small>Select to Connect or Disconnect:</small></label><br />
            </div>

            <!-- Budget -->
            <div class="row margin-top-bottom-10" *ngIf="showBudget">
              <div class="col-12">
                Enter Monthly Desired Budget $ <input type="number" id="budget" [(ngModel)]="budget" />
              </div>
            </div>
            <div class="row margin-top-bottom-10" *ngIf="showBudget">
              <div class="col-5">
                <div type="button" (click)="cancelBudget()" class="btn btn-default">Cancel</div>
                <div type="button" (click)="upsertAccountBudget(budget)" class="btn btn-danger btn-sm">Submit Budget</div>
              </div>
            </div>

            <div *ngIf="showDiscoSelect">
              <select id="showDiscoSelect" (change)="selectChanged($event)" class="form-control">
                <option *ngFor="let o of shutOffOptions" [ngValue]="o">{{o.name}}</option>
              </select>
            </div>

            <!-- Disco Start -->
            <div class="margin-top-bottom-10" *ngIf="showCalendar">
              <label class="bp-text float-left"><small>Select Disconnect Date:</small></label><br />
            </div>
            <dx-date-box *ngIf="showCalendar"
                         [(value)]="datevalue"
                         [min]="now"
                         style="display: inline-block; padding-right: 0; width: 200px !important; color: #000"
                         (onValueChanged)="dateValueChanged('disco', $event)">
            </dx-date-box>

            <div class="margin-top-bottom-10" *ngIf="showCalendar && showTwoFactorSelect">
              <label class="bp-text" for="previousSelect"><small>2-Factor Communication Preference:</small></label>
              <br />
              <select class="form-control" style="width: 250px !important;" (change)="setTwoFactor($event.target.value)">
                <option value="email">Email</option>
                <option value="sms">Text Message</option>
              </select>
            </div>

            <div [className]="accepted ? 'green-border' : 'red-border'" class="margin-top-bottom-10 terms" *ngIf="showCalendar && discoSelected">
              <p>
                YOU HAVE REQUESTED TO DISCONNECT YOUR WATER SERVICE ON <b>{{dateselcted}}</b>.
                <br />BEFORE YOUR SCHEDULED DISCONNECT CAN BE COMPLETED YOU MUST SELECT BELOW TO AGREE THAT YOU OR SOMEONE YOU AUTHORIZE WILL BE AT THE LOCATION ON <b>{{dateselcted}}</b>
                WHEN YOUR WATER SERVICE IS SCHEDULED TO BE DISCONNECTED.
                <br />BY AGREEING TO BE AT THIS LOCATION YOU ALSO AGREE TO NOT HOLD <b>{{orgUnitName}}</b>
                RESPONSIBLE FOR ANY PROPERTY DAMAGE CAUSED BY WATER DESTROYING OR DAMAGING ANY PERSONAL PROPERTY RESULTING FROM FAUCETS THAT WERE LEFT ON WHEN YOUR WATER SERVICE WAS CONNECTED.
              </p>
            </div>

            <div [className]="accepted ? 'green-border' : 'red-border'" class="checkboxes" *ngIf="showCalendar && discoSelected">
              <label for="x"><input type="checkbox" id="x" (change)="fieldsChange($event)" /> <span>I <b>{{ customerInfo?.FirstName == null ? '--' : customerInfo.FirstName }} {{ customerInfo?.LastName == null ? '--' : customerInfo.LastName }}</b>  ACCEPT AND AGREE.</span></label>
            </div>

            <div class="row margin-top-bottom-10" *ngIf="showCalendar && accepted">
              <div class="col-12">
                <div type="button" (click)="sendDisconnectInfoInitial(currentAccount, datevalue)" class="btn btn-danger btn-sm">Submit Disconnect Info</div>
              </div>
            </div>
            <!-- Disco End -->
            <!-- Temp Disco Start -->
            <div class="margin-top-bottom-10" *ngIf="showTempDisco">
              <label class="bp-text float-left"><small>Select Connect Date:</small></label><br />
            </div>
            <dx-date-box *ngIf="showTempDisco"
                         [(value)]="startdatevalue"
                         [min]="now"
                         style="display: inline-block; padding-right: 0; width: 200px !important; color: #000"
                         (onValueChanged)="dateValueChanged('reco', $event)">
            </dx-date-box>
            <div class="margin-top-bottom-10" *ngIf="showTempDisco && showTwoFactorSelect">
              <label class="bp-text" for="previousSelect"><small>2-Factor Communication Preference:</small></label>
              <br />
              <select class="form-control" style="width: 250px !important;" (change)="setTwoFactor($event.target.value)">
                <option value="email">Email</option>
                <option value="sms">Text Message</option>
              </select>
            </div>

            <div [className]="accepted ? 'green-border' : 'red-border'" class="margin-top-bottom-10 terms" *ngIf="showTempDisco && discoSelected">
              <p>
                YOU HAVE REQUESTED TO CONNECT YOUR WATER SERVICE ON <b>{{dateselcted}}</b>.
                <br />BEFORE YOUR SCHEDULED CONNECT CAN BE COMPLETED YOU MUST SELECT BELOW TO AGREE THAT YOU OR SOMEONE YOU AUTHORIZE WILL BE AT THE LOCATION ON <b>{{dateselcted}}</b>
                WHEN YOUR WATER SERVICE IS SCHEDULED TO BE CONNECTED.
                <br />BY AGREEING TO BE AT THIS LOCATION YOU ALSO AGREE TO NOT HOLD <b>{{orgUnitName}}</b>
                RESPONSIBLE FOR ANY PROPERTY DAMAGE CAUSED BY WATER DESTROYING OR DAMAGING ANY PERSONAL PROPERTY RESULTING FROM FAUCETS THAT WERE LEFT ON WHEN YOUR WATER SERVICE WAS CONNECTED.
              </p>
            </div>

            <div [className]="accepted ? 'green-border' : 'red-border'" class="checkboxes" *ngIf="showTempDisco && discoSelected">
              <label for="x"><input type="checkbox" id="x" (change)="fieldsChange($event)" /> <span>I <b>{{ customerInfo?.FirstName == null ? '--' : customerInfo.FirstName }} {{ customerInfo?.LastName == null ? '--' : customerInfo.LastName }}</b>  ACCEPT AND AGREE.</span></label>
            </div>

            <div class="row margin-top-bottom-10" *ngIf="showTempDisco && accepted">
              <div class="col-12">
                <div type="button" (click)="sendTempShutOffInfo(currentAccount, startdatevalue, enddatevalue)" class="btn btn-danger btn-sm">Submit Connect Info</div>
              </div>
            </div>
            <!-- Temp Disco End -->
            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInputTemp">
              <label class="float-left blue-text bp-bold-text"><small>Enter the code that was sent to your {{twoFactorSource}}, to complete this request:</small></label>
            </div>
            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInputTemp">
              <input name="showTwoFactorInput" class="form-control _300PxWide" type="text" id="twoFactorInput" maxlength="10" [(ngModel)]="twoFactorInput" />
            </div>
            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInputTemp">
              <div class="col-12">
                <div type="button" (click)="validateTwoFactorCodeTemp(twoFactorInput)" class="btn btn-success btn-sm">Submit 2-Factor Code</div>
              </div>
            </div>

            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInput">
              <label class="float-left blue-text bp-bold-text"><small>Enter the code that was sent to your {{twoFactorSource}}, to complete this request:</small></label>
            </div>
            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInput">
              <input name="showTwoFactorInput" class="form-control _300PxWide" type="text" id="twoFactorInput" maxlength="10" [(ngModel)]="twoFactorInput" />
            </div>
            <div class="row margin-top-bottom-10" *ngIf="showTwoFactorInput">
              <div class="col-12">
                <div type="button" (click)="validateTwoFactorCode(twoFactorInput)" class="btn btn-success btn-sm">Submit 2-Factor Code</div>
              </div>
            </div>

            <div class="row margin-top-bottom-10" *ngIf="showDiscoSelect">
              <div class="col-12">
                <div type="button" (click)="cancelShutOffSelect()" class="btn btn-default">Cancel</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="panel panel-card usage-top-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-bell payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Usage Alerts</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body usage-top-card-content">
          <div class="row">
            <div class="col-sm-12">
              <p class="font-weight-light bp-text">
                Sign up now to receive notifications by text or email.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <app-flow-alerts></app-flow-alerts>
              <app-vacation-alert></app-vacation-alert>
              <app-cold-weather-alerts></app-cold-weather-alerts>
              <app-water-usage-alerts></app-water-usage-alerts>
              <app-budget-alerts></app-budget-alerts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="panel panel-card usage-top-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-map-marker-alt payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Location</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body ">
          <div class="col-lg-12">
            <div #gmap style="width: 100%; height: 335px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row row3">
  <div class="col-md-12">
    <div class="panel panel-card usage-middle-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-chart-bar payment-options-icon float-left"></i>
            <p class="font-weight-light bp-text">
              Recent Water Usage
            </p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body recent-usage-content">
          <div class="row">
            <div class="col-3">
              <dx-button class="row-element link-right"
                         icon="print"
                         text="Print"
                         (onClick)="print()">
              </dx-button>
              <dx-button class="row-element link-right"
                         icon="export"
                         text="Export PNG"
                         (onClick)="export()">
              </dx-button>
            </div>
            <dx-button class="row-element link-right"
                       icon="export"
                       text="Export Excel"
                       (onClick)="downloadGridData()">
            </dx-button>

            <!-- Hidden DataGrid -->
            <div style="display: none;">
              <dx-data-grid #dataGrid
                            [dataSource]="usageDs"
                            [columns]="dataGridColumns">
              </dx-data-grid>
            </div>

            <div class="col-9">
              <div class="form-inline">
                <select class="form-control" (change)="setTimeRange($event.target.value)">
                  <option label="24 hours" value="24 hours">24 hours</option>
                  <option label="7 days" value="7 days">7 days</option>
                  <option label="30 days" value="30 days" selected>30 days</option>
                  <option label="90 days" value="90 days">90 days</option>
                  <option label="12 months" value="12 months">12 months</option>
                  <option label="Custom" value="CustomDate">Custom</option>
                </select>
                <button *ngIf="!showCompare && !showCustom && needCompare" class="btn-circle btn-link" (click)="setShowCompare()">Compare</button>
                <button *ngIf="showCompare && !showCustom && needCompare" class="btn-circle btn-link" (click)="hideCompare()">Hide Compare</button>
              </div>
            </div>
            <div class="col-3"><label>Consumption Past {{timeRange}}: <span class="bp-text">{{usageTotal | number}} {{consumptionTypeDisplay}}</span></label></div>
          </div>

          <div *ngIf="showCustom" class="row">
            <div class="col-md-3">
              <label class="margin-top-bottom-10">Custom Range Start Date</label>
              <br />
              <dx-date-box [(value)]="customValueStart"
                           [max]="now"
                           style="display: inline-block; padding-right: 0; width: 250px !important; margin: 0px 5px 0px 5px !important;"
                           id="datePickerCustomStart">
              </dx-date-box>
            </div>
            <div class="col-md-3">
              <label class="margin-top-bottom-10">Custom Range End Date</label>
              <br />
              <dx-date-box [(value)]="customValueEnd"
                           [max]="tomorrow"
                           style="display: inline-block; padding-right: 0; width: 250px !important; margin: 0px 5px 0px 5px !important;"
                           id="datePickerCustomStartEnd">
              </dx-date-box>
            </div>
            <div class="col-md-6">
            </div>
          </div>

          <div *ngIf="showCustom" class="row">
            <div class="col-md-12 margin-top-bottom-10 padding-left-20">
              <button class="btn-circle btn-primary" (click)="customUsage(timeRange, customValueStart, customValueEnd)">Apply</button>
            </div>
          </div>

          <div *ngIf="showCompare && !showCustom" class="row">
            <div class="col-md-3 no-padding">
              <label class="margin-top-bottom-10" for="previousSelect">Compare To</label>
              <br />
              <select id="previousSelect" class="form-control" style="width: 250px !important;" (change)="setCompareTimeRange($event.target.value)">
                <option *ngIf="timeRange === '24 hours'" label="Previous 24 hours" value="Previous 24 hours">Previous 24 hours</option>
                <option *ngIf="timeRange === '24 hours'" label="Custom Date Range" value="CustomDate">Custom Date Range</option>
                <option *ngIf="timeRange === '7 days'" label="Previous 7 days" value="Previous 7 days">Previous 7 days</option>
                <option *ngIf="timeRange === '7 days'" label="Custom Date Range" value="CustomDate">Custom Date Range</option>
                <option *ngIf="timeRange === '30 days'" label="Previous 30 days" value="Previous 30 days" selected>Previous 30 days</option>
                <option *ngIf="timeRange === '30 days'" label="Custom Date Range" value="CustomDate">Custom Date Range</option>
              </select>
            </div>
            <div *ngIf="loadDatePicker" class="col-md-3 no-padding">
              <label class="margin-top-bottom-10">Custom Range End Date</label>
              <dx-date-box [(value)]="value"
                           [max]="minDate"
                           style="display: inline-block; padding-right: 0; width: 250px !important; margin: 0px 5px 0px 5px !important;"
                           id="datePickerCustom"
                           *ngIf="compareTimeRange !== 'Previous 24 hours'">
              </dx-date-box>
              <dx-date-box [(value)]="value"
                           [max]="minDate"
                           type="datetime"
                           style="display: inline-block; padding-right: 0; width: 250px !important; margin: 0px 5px 0px 5px !important;"
                           id="datePickerCustom"
                           *ngIf="compareTimeRange === 'Previous 24 hours'">
              </dx-date-box>
            </div>
            <div class="col-md-6 no-padding"></div>
          </div>
          <div *ngIf="showCompare" class="row">
            <div class="col-md-12 no-padding margin-top-bottom-10">
              <button class="btn-circle btn-primary" (click)="getWaterUsageCompareData(compareTimeRange, value)">Apply</button>
              <br />
              <span *ngIf="showCustomRangeMsg">{{customRangeMsg}}</span>
            </div>
          </div>


          <div *ngIf="!contextCompare">
            <dx-chart id="recentUsageChart"
                      [dataSource]="usageDs"
                      [argumentAxis]="{
                                    label: {
                                      overlappingBehavior: 'rotate',
                                      rotationAngle: 45,
                                      format: 'shortDateShortTime'
                                    },
                                    tick: { visible: true }
                                 }">
              <dxo-legend position="outside"
                          horizontalAlignment="center"
                          verticalAlignment="bottom">
              </dxo-legend>
              <dxo-common-series-settings argumentField="date">
              </dxo-common-series-settings>
              <dxi-series axis="usageAxis"
                          valueField="usage"
                          name="Usage"
                          type="bar"
                          color="#165a99">
                <dxo-label [visible]="false"
                           [customizeText]="customizeText"
                           title="consumptionType">
                </dxo-label>
              </dxi-series>
              <dxi-series axis="costAxis"
                          type="spline"
                          valueField="cost"
                          name="Cost"
                          color="#00FF00">
              </dxi-series>
              <!--<dxi-series axis="budgetAxis"
                          valueField="budget"
                          name="Budget"
                          type="line"
                          color="#DAF7A6">
              </dxi-series>-->
              <dxi-value-axis name="usageAxis"
                              position="left">
                <dxo-grid [visible]="true"></dxo-grid>
              </dxi-value-axis>
              <dxi-value-axis name="costAxis"
                              position="right">
                <dxo-grid [visible]="true"></dxo-grid>
              </dxi-value-axis>
              <dxo-tooltip [enabled]="true"
                           [customizeTooltip]="customizeTooltip">
              </dxo-tooltip>
            </dx-chart>
          </div>

          <div *ngIf="contextCompare">
            <dx-chart id="recentCompareUsageChart"
                      [dataSource]="compareUsageDs"
                      [valueAxis]="{
                                    label: {
                                        customizeText: customizeText
                                    }
                                 }"
                      [argumentAxis]="{
                                    label: {
                                      overlappingBehavior: 'rotate',
                                      rotationAngle: 45,
                                      format: 'shortDateShortTime'
                                    },
                                    tick: { visible: true }
                                 }">
              <dxo-legend position="outside"
                          horizontalAlignment="center"
                          verticalAlignment="bottom">
              </dxo-legend>
              <dxo-common-series-settings argumentField="date">
              </dxo-common-series-settings>
              <dxi-series valueField="usage"
                          name="Usage"
                          type="bar"
                          color="#165a99">
              </dxi-series>
              <dxi-series valueField="usage2"
                          name="Usage Date Range Comparison"
                          type="bar"
                          color="#cfe2f3">
              </dxi-series>
              <dxo-tooltip [enabled]="true"
                           [customizeTooltip]="customizeTooltip">
              </dxo-tooltip>
            </dx-chart>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>

<div class="row row4">

  <div class="col-md-8 margin-bottom-md">
    <div class="panel panel-card usage-bottom-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-hourglass-half payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">FAQs</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body">
          <div id="faqs">
            <ul class="faqUL">
              <li (click)="toggleli_one()">
                How much water am I using?
              </li>
              <li class="infoText" *ngIf="showli_one">
                <p>You can view your water usage in a variety of ways in the OMNIA Customer Portal. Your total usage for the prior 30 days can be found under your Account Details on the Usage page. Just look for ‘Consumption Last 30 Days’ for your total usage in gallons.</p>

                <p>You can also view your water usage in the ‘Recent Water Usage’ chart. This chart is dynamic and allows you to select the time period over which you would like to view your consumption. You can view your daily water consumption over the past 30 days, the past 7 days, or hourly usage over the past 24 hours.</p>

              </li>
              <li (click)="toggleli_two()">How do I sign up for water Usage Alerts?</li>
              <li class="infoText" *ngIf="showli_two">
                <p>
                  You can subscribe to a variety of water usage alerts from ‘Usage Alerts’ tile on the home page or from the Alerts & Communications tile in the ‘My Profile’ page of the Customer Portal. You can choose to receive water Usage Alerts by either email or text message.
                </p>
              </li>
              <li (click)="toggleli_three()">How do I update my contact information to receive water usage alerts?</li>
              <li class="infoText" *ngIf="showli_three">
                <p>
                  Just click the ‘My Profile’ link at the top of the page and then select the ‘Contact Information’ tile. From that page you can update your email address and add multiple mobile phone numbers where you would like to receive text notifications.
                </p>
              </li>
              <li (click)="toggleli_four()">What types of water usage alerts are available to me?</li>
              <li class="infoText" *ngIf="showli_four">
                <p>
                  The OMNIA Customer Portal offers a suite of water Usage Alerts depending on your particular needs:
                </p>
                <ul>
                  <li class="alertText">Flow Alert –  This alert covers four different categories of possible alerts, Back Flow (water is flowing in reverse), Continuouse Flow (water is continuously flowing), No Flow (there has been no water flow for a while), and Excessive Flow (water flow is flowing more than average).</li>
                  <li class="alertText">Vacation Alert – If any flow (or the amount set by you) is detected during pre-determined dates</li>
                  <li class="alertText">Cold Weather Alert – If temperature drops below a selectable threshold</li>
                  <li class="alertText">Water Usage Alert – If consumption exceeds a configurable percentage of your average water flow</li>
                </ul>
              </li>
              <li (click)="toggleli_five()">Can I track my water usage alert history?</li>
              <li class="infoText" *ngIf="showli_five">
                <p>
                  All of your Usage Alerts are tracked and available to view under the ‘Usage Alerts’ tab at the bottom of the ‘Usage’ page. You can search the history for any type of alert on a particular date, or you can sort the alert list by alarm type, alarm data, or notification status.
                </p>
              </li>
              <li><a class="auth-row-a" routerLink="/CustService/FAQs"><b>See More FAQs</b></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-md-4 margin-bottom-md">
    <div class="panel panel-card usage-bottom-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-hourglass-half payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Usage Alert History</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body">
          <div id="alertHistory">
            <dx-tree-list id="tasks"
                          [dataSource]="alarms"
                          [columnAutoWidth]="true"
                          [wordWrapEnabled]="true"
                          [showBorders]="true"
                          noDataText="No Alert History Found">
              <dxo-search-panel [visible]="true"></dxo-search-panel>
              <dxi-column dataField="alarmType"></dxi-column>
              <dxi-column dataField="recorded" caption="Alarm Date" dataType="datetime" [customizeText]="customizeAlarmDateText.bind(this)"></dxi-column>
              <dxi-column dataField="notificationSent" caption="Alert Sent?" showEditorAlways="false" trueText="Yes" falseText="No"></dxi-column>
            </dx-tree-list>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<dx-toast [(visible)]="showSuccess"
          type="success"
          message="{{successMessage}}">
</dx-toast>

<dx-toast [(visible)]="showError"
          type="error"
          message="{{errorMessage}}">
</dx-toast>


<div class="backdrop" [ngStyle]="{'display':display}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCloseHandled(dateselcted, contype)"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">For the selected day, please choose from the available times below to {{contypetext}} your water service</h4>
      </div>
      <div class="modal-body times">
        <ul>
          <li *ngFor="let time of times" (click)="onCloseHandled(time.dateUTC, contype)">{{time.dateUTC}}</li>
        </ul>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/usage-container/usage-container.component.html